/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote1': {
    width: 19,
    height: 14,
    viewBox: '0 0 19 14',
    data: '<path pid="0" d="M19 2.187c-2.484 1.214-3.727 2.642-3.727 4.282 1.06.121 1.935.551 2.627 1.29.693.74 1.039 1.595 1.039 2.566 0 1.033-.336 1.903-1.008 2.612-.672.709-1.517 1.063-2.536 1.063-1.14 0-2.128-.46-2.963-1.382-.834-.921-1.252-2.04-1.252-3.356 0-3.947 2.22-7.035 6.66-9.262L19 2.187zm-11.18 0C5.315 3.4 4.063 4.829 4.063 6.469c1.079.121 1.965.551 2.657 1.29.693.74 1.039 1.595 1.039 2.566 0 1.033-.341 1.903-1.023 2.612C6.053 13.646 5.203 14 4.185 14c-1.14 0-2.123-.46-2.948-1.382C.412 11.697 0 10.578 0 9.262 0 5.315 2.21 2.227 6.629 0l1.19 2.187z" _fill="#000" fill-rule="evenodd"/>'
  }
})
